import react from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { UserRole } from '../../models/User'
import { Card, CardTitle, CardContent } from '../Layout/CommonStyle'
import { Link } from 'react-router-dom'

type Props = {
  name: string
  button: string
  url: string
}

function JobTestBox(props: Props) {
  return (
    <Card>
      <CardContent>
        <Title>{props.name}</Title>
        <Link to={props.url}>
          <LinkButton>{props.button}</LinkButton>
        </Link>
      </CardContent>
    </Card>
  )
}

const Title = styled.div`
  margin-top: -20px;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  padding-bottom: 0.5rem;
`
const LinkButton = styled.button`
  background-color: var(--point-color1);
  color: var(--point-text-color1);
  padding: 0.5rem 1rem;
  border: none;
  border: 1px solid var(--point-color1);

  &:hover {
    background-color: #7c0a0a;
    border: 1px solid var(--point-color2);
  }
`
export default JobTestBox
